import styled from 'styled-components'
import SignInContainer from '@ui/sign-in-container/SignInContainer'
import React from 'react'
import {NavLink, useLocation, useNavigate} from 'react-router-dom'
import {BASE_ROUTES} from '~/src/routes/constants'
import CheckedBanner from '../../components/auth/CheckedImage'
import SubmitButton from '../../components/auth/SubmitButton'

const ConfirmationContainer = styled('div')`
  justify-content: center;
  text-align: center;
`

const FormTitle = styled('h2')`
  margin: 0 0 var(--space-2);
  color: var(--text-primary);
  font-size: 1.5rem;
  font-weight: var(--fw-bold);
  letter-spacing: -0.025em;
`

const FormSubtitle = styled('h3')`
  margin: 0;
  font-size: var(--fs-body);
  font-weight: var(--fw-regular);
  color: var(--text-secondary);
  padding-bottom: var(--space-8);
`

const ButtonFooter = styled('div')`
  padding-top: var(--space-8);
`

interface LocationState {
  email: string
  isCandidate?: boolean
}

export default function PasswordConfirmation() {
  const navigate = useNavigate()
  const location = useLocation()

  const locationState = location.state as LocationState
  const isCandidate = locationState?.isCandidate === true

  const formSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (isCandidate) {
      navigate('/dashboard')
      return
    }
    navigate(BASE_ROUTES.SIGNIN, {
      state: {
        email: locationState.email,
      },
    })
  }

  return (
    <SignInContainer
      customFooter={
        <NavLink className="nav-link" to={BASE_ROUTES.SIGNIN}>
          <div>
            Back to <u>Sign In</u>
          </div>
        </NavLink>
      }>
      <ConfirmationContainer>
        <FormTitle>Password Updated</FormTitle>
        <FormSubtitle>Your password has been updated!</FormSubtitle>
        <form onSubmit={(e) => formSubmit(e)}>
          <CheckedBanner />

          <ButtonFooter>
            <SubmitButton>
              {isCandidate ? 'Proceed to Dashboard' : 'Proceed to Application'}
            </SubmitButton>
          </ButtonFooter>
        </form>
      </ConfirmationContainer>
    </SignInContainer>
  )
}
